import { THEME } from '@cs-cms/types';
import { AppTheme } from './ThemeContext';

let currentThemeLink: HTMLLinkElement | null = null;
let customizationsLink: HTMLLinkElement | null = null;

const reapplyCustomStyles = () => {
  const customLink = document.createElement('link');
  customLink.rel = 'stylesheet';
  customLink.href = '/static/css/material-customizations.css';
  document.head.appendChild(customLink);
  customizationsLink = customLink;
};

const removeCustomStyles = () => {
  if (customizationsLink) {
    document.head.removeChild(customizationsLink);
    customizationsLink = null;
  }
};

export const loadTheme = async (theme: AppTheme) => {
  if (currentThemeLink) {
    document.head.removeChild(currentThemeLink);
    currentThemeLink = null;
  }

  if (theme === THEME.LIGHT) {
    removeCustomStyles();
    return Promise.resolve();
  }

  const themeLink = document.createElement('link');
  themeLink.rel = 'stylesheet';
  themeLink.href = '/static/css/theme-dark.css';

  return new Promise<void>((resolve, reject) => {
    themeLink.onload = () => {
      reapplyCustomStyles();
      resolve();
    };
    themeLink.onerror = () => reject(new Error(`Failed to load ${theme} theme`));
    document.head.appendChild(themeLink);
    currentThemeLink = themeLink;
  });
};
